import { useFormContext, type FieldPath } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Render } from '@/components/render-if'
import { Button } from '@/components/ui'
import { CardPlanta } from '@/features/proposta/components/card-planta-bloco'
import { CardVendedorResponsavel } from '@/features/proposta/components/card-vendedor-responsavel'
import { CardVagaPadrao } from '@/features/proposta/components/vaga-padrao/card-vaga-padrao'
import { PropostaProvider } from '@/features/proposta/context/proposta-context'
import { useStepValidationStrategy } from '@/features/proposta/hooks'
import {
  StepPropostaContent,
  StepPropostaHeaderContent,
  StepPropostaHeaderTitle,
  StepPropostaRoot,
  StepPropostaFooter,
  StepPropostaHeaderDescription,
} from '@/features/proposta/layouts'
import type { TPropostaSchemaInput } from '@/features/proposta/schemas'

export const InformacoesIniciaisStep = () => {
  const { t } = useTranslation('proposta')
  const { watch, trigger, setValue } = useFormContext<TPropostaSchemaInput>()

  const { validateStep } = useStepValidationStrategy(trigger)

  const handleNextStep = async () => {
    const isValid = await validateStep('InformacoesIniciaisStep')
    if (!isValid) return
    setValue('step', 1)
  }

  const simulacaoUnidade = watch('informacoesIniciais.simulacaoUnidade' as FieldPath<TPropostaSchemaInput>)

  return (
    <StepPropostaRoot>
      <StepPropostaHeaderContent>
        <StepPropostaHeaderTitle className="hidden md:block">
          {t('informacoes_iniciais.titulo')}
        </StepPropostaHeaderTitle>
        <StepPropostaHeaderDescription className="hidden md:block">
          {t('informacoes_iniciais.subtitulo')}
        </StepPropostaHeaderDescription>
      </StepPropostaHeaderContent>
      <StepPropostaContent>
        <PropostaProvider
          idExternoBlocoPath="informacoesIniciais.simulacaoUnidade.bloco.idExterno"
          vendedorAlocadoIdPath="informacoesIniciais.vendedorAlocadoCliente"
          dataMarcacaoAlvenariaPath="informacoesIniciais.simulacaoUnidade.produto.dataMarcacaoAlvenaria"
        >
          <div className="flex w-full flex-wrap gap-4">
            <Render.If condition={simulacaoUnidade}>
              {() => (
                <>
                  <CardVagaPadrao />
                  <CardPlanta />
                </>
              )}
            </Render.If>
            <CardVendedorResponsavel />
          </div>
        </PropostaProvider>
      </StepPropostaContent>
      <StepPropostaFooter className="justify-end">
        <Button className="font-nunito h-12 w-full md:w-auto" variant="default" onClick={handleNextStep}>
          {t('proxima_etapa')}
        </Button>
      </StepPropostaFooter>
    </StepPropostaRoot>
  )
}
